import { render } from "./Facture.vue?vue&type=template&id=0a34610e"
import script from "./Facture.vue?vue&type=script&lang=js"
export * from "./Facture.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__